import React from "react";
import { Navigate } from "react-router-dom";
import GetStorage from "../services/Storage";
import { useLocation } from "react-router-dom";

const ProtectedRoutes = ({ children }) => {
  const location = useLocation();
  console.log("location---->", location);
  const locArr = location.pathname.split("/");

  const exactRoute = `${locArr[1]}/${locArr[2]}`;
  console.log("loca------2", locArr[3]);

  const user = GetStorage.get("xAuthToken");
  if (!user) {
    if (exactRoute === "applicant/profile");
    {
      const id = locArr[3];
      localStorage.setItem("screen", JSON.stringify([exactRoute, id]));
    }
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoutes;
